{
  "settings": {
    "audit": {
      "dataSources": "Dátové zdroje",
      "functions": "Funkcie",
      "generalSettings": "Základné nastavenia",
      "modules": "Moduly",
      "notificationTemplates": "Notifikačné šablóny",
      "numbers": "Počet dní uchovávania audit logov",
      "roles": "Role",
      "tables": "Tabuľky",
      "templates": "Šablóny",
      "title": "Audítorský protokol",
      "users": "Používatelia"
    },
    "colors": {
      "primary": "Primárny text",
      "primaryBG": "Primárne pozadie",
      "secondary": "Sekundárny text",
      "secondaryBG": "Sekundárne pozadie",
      "title": "Farby"
    },
    "dashboard": {
      "addKPI": "Pridať KPI",
      "addWidget": "Pridať agendu",
      "noKPI": "Nie sú definované žiadne KPI",
      "requiredKPI": "KPI musia obsahovať aspoň jednu položku.",
      "noAgendas": "Nie sú definované žiadne agendy",
      "requiredAgendas": "Prehľady musia obsahovať aspoň jednu položku.",
      "placeholder": "Nastavenie dashboardu",
      "title": "Nastavenie dashboardu",
      "modules": "Moduly",
      "agendas": "Agendy",
      "views": "Prehľady",
      "color": "Farba",
      "agendaViewSettings": "Nastavenie prehľadu agendy",
      "kpiSettings": "Nastavenie KPI",
      "deleteDashboard": "Zmazať dashboard",
      "deleteDashboardConfirmationText": "Týmto sa zmaže aktuálny dashboard a všetky jeho nastavenia. Ste si istý, že chcete pokračovať?",
      "sourceSelect": "Zdroj",
      "heliosSqlScript": "Helios SQL skript",
      "view": "Prehľad",
      "link": "Odkaz",
      "linkUrl": "URL odkazu",
      "linkText": "Nadpis odkazu",
      "heliosDataSource": "Helios dátový zdroj",
      "heliosScript": "Helios skript",
      "itemsSettingRequired": "Všetky položky musia byť nastavené",
      "dashboardDataError": "Chyba pri načítaní dát dashboardu",
      "agendaView": "Prehľad agendy",
      "kpiItem": "KPI",
      "notification": "Neprečítané informácie",
      "notificationWithAction": "Nevybavené úlohy",
      "groupByModule": "Zoskupovať podľa modulu",
      "showRecordCount": "Zobraziť počet záznamov"
    },
    "email": {
      "placeholder": "Napíšte e-mail",
      "text": "E-mail",
      "title": "E-mail pre nahlasovanie chýb",
      "required": "Email je povinný",
      "invalid": "Email je neplatný"
    },
    "contactEmail": {
      "invalid": "Email je neplatný"
    },
    "date": {
      "from": "Vyžaduje sa platnosť od",
      "to": "Vyžaduje sa platné do",
      "minDate": "Platné do musí byť väčšie ako Platné od",
      "today": "Platné do musí byť po dnešku"
    },
    "error": {
      "loginRequired": "Možno vybrať iba jedno"
    },
    "login": {
      "google": "Google prihlásenie",
      "microsoft": "Microsoft prihlásenie",
      "title": "Nastavenie metódy prihlásenia",
      "warning": "Meníte spôsob prihlásenia. Po uložení zmien môžu byť spôsobené problémy s prístupom do aplikácie."
    },
    "recordVersioning": {
      "title": "Vytváranie verzií záznamov",
      "invalidMode": "Vyberte platný režim vytvárania verzií záznamov.",
      "options": {
        "AllUpdates": "Pri každej aktualizácii",
        "UiUpdatesOnly": "Iba pri priamych úpravách v používateľskom rozhraní",
        "IncreaseVersionOnly": "Iba pri spustení akcie „Zvýšiť verziu“"
      },
      "descriptions": {
        "AllUpdates": "Uloží historickú verziu pri každej aktualizácii záznamu vrátane zmien vykonaných akciami a integráciami.",
        "UiUpdatesOnly": "Uloží historickú verziu pri priamej úprave záznamu v používateľskom rozhraní, pred vykonaním nadväzujúcich akcií. Zmeny vykonané týmito akciami ani integráciami ďalšiu verziu nevytvoria.",
        "IncreaseVersionOnly": "Uloží novú hlavnú verziu aktuálneho stavu záznamu iba pri spustení akcie „Zvýšiť verziu“."
      }
    },
    "recordLock": {
      "title": "Zámok záznamu",
      "duration": "Doba zámku záznamu (min)",
      "range": "Zadajte celé číslo od 1 do 120 minút."
    },
    "templates": {
      "text": "Počet záznamov v pohľadoch",
      "title": "Nastavenie pohľadov"
    },
    "user": {
      "profile": "Profil",
      "pageSize": {
        "title": "Nastavenie pohľadov",
        "label": "Počet záznamov v pohľadoch"
      },
      "fastSignIn": {
        "title": "Rýchle prihlásenie",
        "recommended": "Odporúčané",
        "changePin": "Zmeniť PIN kód",
        "pin": {
          "title": "PIN kód",
          "subtitle": "6-miestny PIN – rýchly a bezpečný"
        },
        "biometry": {
          "title": "Face ID",
          "subtitle": "Prihlásiť sa pohľadom – okamžité"
        },
        "fingerprint": {
          "title": "Odtlačok prsta",
          "subtitle": "Prihlásiť sa odtlačkom prsta – okamžité"
        },
        "none": {
          "title": "Žiadne",
          "subtitle": "Nepoužívať rýchle prihlásenie"
        },
        "actionRequired": {
          "title": "Vyžadovaná akcia",
          "body": "Nastavte spôsob rýchleho prihlásenia. Aplikáciu môžete zatiaľ používať bez obmedzení."
        },
        "confirmNone": {
          "title": "Vypnúť rýchle prihlásenie?",
          "body": "Naozaj chcete vypnúť rýchle prihlásenie? Aplikáciu už neodomknete pomocou PIN alebo biometrie."
        }
      }
    },
    "contacts": {
      "showContacts": "Zobrazovať Rozdeľovník",
      "title": "Rozdeľovník"
    }
  },
  "users": {
    "adminPermissions": "Administrátorské oprávnenia",
    "impersonate": "Impersonovať",
    "cancel_impersonate": "Zrušiť impersonáciu",
    "cancel_substitution": "Vrátit sa do môjho zobrazenia",
    "currently_substituting": "Aktuálne zastupujem používateľa:",
    "start_impersonation_error": "Nepodarilo sa spustiť impersonáciu",
    "stop_impersonation_error": "Nepodarilo sa zrušiť impersonáciu",
    "validToBeforeValidFrom": "Platnosť do musí byť väčšia ako platnosť od"
  },
  "roles": {
    "table": {
      "name": "Názov role"
    },
    "deleteConfirmation": "Naozaj chcete zmazať vybrané roly? Táto akcia je nevratná.",
    "selectByTag": "Po skupinách",
    "selectIndividually": "Jednotlivo",
    "tags": {
      "title": "Štítky",
      "addTag": "Pridať alebo vybrať štítok",
      "placeholder": "Zadajte pre pridanie nového štítku alebo vyberte existujúci"
    }
  },
  "modules": {
    "name": "Názov",
    "deleteConfirmation": "Naozaj chcete zmazať vybrané moduly? Táto akcia je nevratná.",
    "renameModule": "Premenovať modul",
    "attachModule": "Pripnúť modul",
    "dashboardSettings": "Nastavenia dashboardu",
    "isChildModule": "Je podriadený modul",
    "showRecordPreview": "Zobrazovať náhled záznamov",
    "parentModule": "Nadriadený modul",
    "selectParentModule": "Vyberte nadriadený modul"
  },
  "assistants": {
    "addTitle": "Pridať asistenta",
    "editTitle": "Upraviť asistenta",
    "search": "Hľadať asistentov",
    "labelSection": "Názov",
    "descriptionSection": "Popis",
    "idSection": "ID asistenta",
    "vsgAssistantId": "VSG ID asistenta",
    "deleteConfirmation": "Naozaj chcete zmazať tohto asistenta? Táto akcia je nevratná.",
    "description_En": "Popis (EN)",
    "description_Sk": "Popis (SK)",
    "description_Cs": "Popis (CZ)"
  },
  "substitutability": {
    "showToUsers": "Zobraziť možnosť zastupiteľnosti používateľom",
    "showInSubstituted": "Zobrazovať v zastupovaných používateľa",
    "options": {
      "visible": "Áno",
      "hidden": "Nie"
    },
    "listingType": {
      "None": "Žiadny",
      "AllUsers": "Všetky",
      "OneUserRole": "S jednou rovnakou rolou",
      "AllUserRoles": "S rovnakými rolami"
    }
  }
}
